import React, { Component } from 'react';
import './style.css';

import {
  Button,
  Form,
  Message,
  Grid,
  Input,
  Header,
  Segment,
} from 'semantic-ui-react';

import { checkStatus, getRedirectUrl, getQueryVariable } from './utils';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      error: '',
      signIn: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  login(e) {
    e.preventDefault();
    const CRM_API_ROOT = process.env.REACT_APP_CRM_API_ROOT;
    const url = `${CRM_API_ROOT}/tokens`;
    const { email, password } = this.state;
    this.setState({ loading: true });
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      mode: 'cors', // no-cors, cors, *same-origin
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(({ token }) => {
        const redirectUrl = getRedirectUrl(getQueryVariable('ref'));
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }
        this.setState({ signIn: true });
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.setState({ error: 'Nieprawidłowy login lub hasło' });
        }
        this.setState({ loading: false });
      });
  }
  render() {
    const noModuleAccess = getQueryVariable('noModuleAccess');
    return (
      <Grid centered verticalAlign="middle">
        <Grid.Column computer="4" mobile="14" tablet="8">
          {!this.state.signIn &&
            !noModuleAccess && (
              <Segment loading={this.state.loading} vertical>
                <Header textAlign="center" as="h3">
                  Wprowadź dane logowania
                </Header>
                <Form size="large" onSubmit={this.login}>
                  <Segment stacked secondary>
                    <Form.Field>
                      <Input
                        icon="user"
                        iconPosition="left"
                        onChange={this.handleChange}
                        name="email"
                        type="text"
                        placeholder="email"
                      />
                    </Form.Field>
                    <Form.Field>
                      <Input
                        icon="lock"
                        iconPosition="left"
                        onChange={this.handleChange}
                        name="password"
                        type="password"
                        placeholder="hasło"
                      />
                    </Form.Field>
                    <Button fluid size="large" color="teal" type="submit">
                      Zaloguj
                    </Button>
                  </Segment>
                </Form>
                {this.state.error.length > 0 && (
                  <Message warning content={this.state.error} />
                )}
              </Segment>
            )}
          {this.state.signIn && (
            <Header textAlign="center" as="h3">
              Zostałeś zalogowany
            </Header>
          )}
          {noModuleAccess && (
            <Header textAlign="center" as="h3">
              Nie masz dostępu danej usługi.
            </Header>
          )}
        </Grid.Column>
      </Grid>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/LoginForm/index.js